import React, { useEffect } from "react";
// REDUX
import { useSelector, useDispatch } from "react-redux";
import {
  updateServerBreadcrumb,
  updateIdServerSelected,
  updateNameServerSelected,
} from "../../../redux/servers/serverSlice";
import {
  updateIdBankSelected,
  updateNameBankSelected,
  updateBankBreadcrumb,
} from "../../../redux/banks/bankSlice";
// COMPONENTS
import BanksHeader from "./BanksHeader";
import BanksTable from "./BanksTable";
import BanksCreateForm from "./BanksCreateEditForm";
import BanksDrawer from "./BanksDrawer";
import BanksDeleteModal from "./BanksDeleteModal";
import BanksDeletedSection from "./BanksDeletedSection";
import BanksRestoreModal from "./BanksRestoreModal";
import KeysAssignInterface from "../keys/KeysAssignInterfaceBank";
// AUTHORIZATION
import { Permission, hasPermission } from "../../../utils/validatePermissions";
import UnauthorizedPage from "../../unauthorized/UnauthorizedPage";
// INTERFACES
import { RootState } from "../../../app/store";

const BanksPage = () => {
  // ************************************************ */
  // GLOBAL VARIABLES ******************************* */
  const dispatch = useDispatch();

  // ************************************************ */
  // USE STATE VARIABLES **************************** */

  // ************************************************ */
  // REDUX SLICE VARIABLES ************************** */
  const { permissionSet } = useSelector((state: RootState) => state.user);
  const { theme } = useSelector((state: RootState) => state.home);

  // ************************************************ */
  // SERVICES AND API CALLS ************************* */

  // ************************************************ */
  // FUNCTIONS ************************************** */

  // ************************************************* */
  // USE EFFECT ************************************** */
  useEffect(() => {
    dispatch(updateServerBreadcrumb([]));
    dispatch(updateBankBreadcrumb([]));
    dispatch(updateIdServerSelected(""));
    dispatch(updateIdBankSelected(""));
    dispatch(updateNameBankSelected(""));
    dispatch(updateNameServerSelected(""));
  }, []);

  // ************************************************ */
  // COMPONENT ************************************** */
  return (
    <div>
      {hasPermission(Permission.ViewEdgeManagementBanks, permissionSet ?? []) ? (
        <div>
          <div className={`layout__contentPage__${theme}`}>
            <BanksHeader />
            <BanksTable />
            <BanksDeletedSection />
            <BanksCreateForm />
            <BanksDrawer />
            <BanksDeleteModal />
            <BanksRestoreModal />
            <KeysAssignInterface />
          </div>
        </div>
      ) : (
        <UnauthorizedPage />
      )}
    </div>
  );
};

export default BanksPage;
